import React from 'react';

const SafeIcon = ({ icon: Icon, size = 24, className = '', ...props }) => {
  if (!Icon) return null;
  return <Icon size={size} className={className} {...props} />;
};

export default SafeIcon;